import script from "./PhasedLightCurvePlot.vue?vue&type=script&setup=true&lang=js"
export * from "./PhasedLightCurvePlot.vue?vue&type=script&setup=true&lang=js"

import "./PhasedLightCurvePlot.vue?vue&type=style&index=0&id=19bb5d1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bb5d1c"]])

export default __exports__